import { render } from "./BasePlannerExamTrainings.vue?vue&type=template&id=f89d098e"
import script from "./BasePlannerExamTrainings.vue?vue&type=script&lang=js"
export * from "./BasePlannerExamTrainings.vue?vue&type=script&lang=js"

import "./BasePlannerExamTrainings.vue?vue&type=style&index=0&id=f89d098e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__